<div class="relative flex w-full flex-col gap-0 text-xs">
  <mat-label
    class="absolute -top-2 left-4"
    [class]="isDisabled() ? 'text-[var(--mat-sys-outline)]' : ''"
    >{{ label() }}
  </mat-label>
  <div
    class="flex h-10 w-full flex-row items-center justify-between overflow-hidden"
    [class]="isDisabled() ? 'text-[var(--mat-sys-outline)]' : ''"
  >
    <div class="flex w-1/2 flex-row items-center overflow-hidden">
      <mat-checkbox
        [ngModel]="choiceTrue()"
        [disabled]="isDisabled()"
        (change)="onValueChange($event.checked, false)"
        color="primary"
        [id]="id() ?? ''"
        [tabIndex]="tabDisabled() ? '-1' : '0'"
        class="h-9 min-h-[18px] min-w-[18px]"
      >
      </mat-checkbox>
      <label
        (click)="onValueChange(!choiceTrue(), false)"
        [class]="isDisabled() ? '' : ''"
        style="text-align: left"
        class="text-base"
      >
        {{ choiceTrueLabel() | siaTranslate }}
      </label>
    </div>
    <div class="flex w-1/2 flex-row items-center overflow-hidden">
      <mat-checkbox
        [ngModel]="choiceFalse()"
        [disabled]="isDisabled()"
        (change)="onValueChange($event.checked, true)"
        color="primary"
        [id]="id() ?? ''"
        [tabIndex]="tabDisabled() ? '-1' : '0'"
        class="h-9 min-h-[18px] min-w-[18px]"
      >
      </mat-checkbox>
      <label
        (click)="onValueChange(!choiceFalse(), true)"
        [class]="isDisabled() ? '' : ''"
        style="text-align: left"
        class="text-base"
      >
        {{ choiceFalseLabel() | siaTranslate }}
      </label>
    </div>
  </div>
  <div class="h-4">
    @if (showBottomMargin()) {
      <mat-hint
        class="left-5 pl-5 text-xs"
        sia-error-hint
        [statusMessage]="statusMessage()"
        [statusMessages]="statusMessages()"
      ></mat-hint>
    }
  </div>
</div>
